import React, { useEffect, useRef } from "react";
import { MANIFESTO } from "../mock";
import dogMask from "../assets/dog.webp";
import airWebm from "../assets/air.webm";
import airMp4 from "../assets/air.mp4";

export default function Manifesto() {
  const ref = useRef(null);
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("in-view")),
      { threshold: 0.15 }
    );
    ref.current?.querySelectorAll(".reveal").forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <section id="manifiesto" ref={ref} style={{ background: "#ffffff" }}>
      <div className="grid lg:grid-cols-2">
        {/* Left: orange panel with sky-filled chihuahua silhouette + phrase */}
        <div className="relative overflow-hidden flex items-center justify-center min-h-[440px] lg:min-h-[680px] px-8 py-16" style={{ background: "#e55b36" }}>
          <div
            className="animate-blob absolute pointer-events-none"
            style={{
              width: "min(78%, 560px)",
              aspectRatio: "985 / 605",
              WebkitMaskImage: `url(${dogMask})`,
              maskImage: `url(${dogMask})`,
              WebkitMaskSize: "contain",
              maskSize: "contain",
              WebkitMaskRepeat: "no-repeat",
              maskRepeat: "no-repeat",
              WebkitMaskPosition: "center",
              maskPosition: "center",
            }}
          >
            <video className="w-full h-full object-cover" autoPlay loop muted playsInline preload="auto">
              <source src={airWebm} type="video/webm" />
              <source src={airMp4} type="video/mp4" />
            </video>
          </div>
          <p className="reveal relative z-10 font-display font-semibold text-center leading-[1.02] text-[40px] md:text-[58px] lg:text-[64px] max-w-[9ch]" style={{ color: "#00101f" }}>
            Las PYMES tienen alma.
          </p>
        </div>

        {/* Right: white content */}
        <div className="flex flex-col justify-center px-8 md:px-14 lg:px-20 py-16 md:py-24">
          <p className="reveal uppercase tracking-[0.35em] text-[12px] mb-4" style={{ color: "#e55b36" }}>{MANIFESTO.eyebrow}</p>
          <h2 className="reveal font-display font-semibold text-[40px] md:text-[58px] leading-none mb-10" style={{ color: "#00101f" }}>{MANIFESTO.heading}</h2>

          <div className="space-y-7">
            {MANIFESTO.lines.map((l, i) => (
              <div key={i} className="reveal border-t pt-6" style={{ borderColor: "rgba(0,16,31,0.12)" }}>
                <p className="font-display text-[22px] md:text-[30px] leading-tight">
                  <span style={{ color: "#4a5a6a" }}>{l.a}</span>{" "}
                  <span style={{ color: "#e55b36" }}>{l.b}</span>
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
